import { useEffect, useState } from 'react';

import { $placementsMap } from '@client/core/atoms/placements';
import { publishAdnamiPlacement } from '@client/core/utils/dom/handleAdsOverlap/handleStickySkyscrapers';
import { listenKeys } from '@podium/store';
import { PlacementId } from '@schibsted-nmp/advertising-shared';

export function useIsBannerAdnamiAd(placementId: PlacementId) {
  const [isAdnami, setIsAdnami] = useState(false);

  useEffect(() => {
    const unsubscribe = listenKeys(
      $placementsMap,
      [`${placementId}.creativeType`],
      (placements) => {
        const placement =
          typeof placements === 'object' && placements[placementId];
        if (!placement) {
          return;
        }
        const { creativeType } = placement;
        if (creativeType === 'adnami') {
          setIsAdnami(true);
        }
      }
    );
    return () => unsubscribe();
  }, [isAdnami, placementId]);

  useEffect(() => {
    if (isAdnami) {
      publishAdnamiPlacement(placementId);
    }
  }, [isAdnami, placementId]); // Effect specifically for handling 'isAdnami' state change

  return isAdnami;
}
